import { Box, CircularProgress, Tab, Tabs } from "@mui/material";
import { Suspense, lazy, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import { PROJECT_WORKSPACE_CONFIG } from "./projectWorkspaceConfig";

const SolarentOperatorCheckNewRequestPage = lazy(
  () => import("../../solarent-operator/checkNewRequest")
);
const SolarentOperatorInProcessRequestPage = lazy(
  () => import("../../solarent-operator/inProcessRequest")
);
const SolarentOperatorAllRequestsPage = lazy(
  () => import("../../solarent-operator/all-requests")
);
const CheckNewRequestPage = lazy(
  () => import("../../management/checkNewRequest")
);
const InProcessRequestPage = lazy(
  () => import("../../management/inProcessRequest")
);
const ManagementAllRequestPage = lazy(
  () => import("../../management/all-request")
);

const OPERATOR_VIEWS = {
  checkNew: {
    label: "بررسی اولیه",
    Component: SolarentOperatorCheckNewRequestPage,
  },
  inProcess: {
    label: "در جریان",
    Component: SolarentOperatorInProcessRequestPage,
  },
  all: {
    label: "همه درخواست‌ها",
    Component: SolarentOperatorAllRequestsPage,
  },
};

const MANAGEMENT_VIEWS = {
  checkNew: {
    label: "بررسی اولیه",
    Component: CheckNewRequestPage,
  },
  inProcess: {
    label: "در جریان",
    Component: InProcessRequestPage,
  },
  all: {
    label: "همه درخواست‌ها",
    Component: ManagementAllRequestPage,
  },
};

const ProjectWorkspaceHubPage = ({ configKey = "solarentOperator" }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get("view") || "inProcess";
  const views = configKey === "management" ? MANAGEMENT_VIEWS : OPERATOR_VIEWS;
  const viewKeys = Object.keys(views);

  const activeView = views[view] ? view : "inProcess";
  const ActiveList = views[activeView].Component;
  const cfg = PROJECT_WORKSPACE_CONFIG[configKey];

  const tabIndex = useMemo(
    () => Math.max(0, viewKeys.indexOf(activeView)),
    [viewKeys, activeView]
  );

  return (
    <Box>
      <BreadcrumbsComponent />
      <Tabs
        value={tabIndex}
        onChange={(_, idx) => {
          const nextView = viewKeys[idx] || "inProcess";
          setSearchParams({ view: nextView }, { replace: true });
        }}
        sx={{ mb: 1, borderBottom: 1, borderColor: "divider" }}
      >
        {viewKeys.map((key) => (
          <Tab key={key} label={views[key].label} />
        ))}
      </Tabs>
      <Suspense
        fallback={
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
            <CircularProgress size={32} />
          </Box>
        }
      >
        <ActiveList hubMode listBackPath={cfg.listPaths.inProcess} />
      </Suspense>
    </Box>
  );
};

export default ProjectWorkspaceHubPage;
